























































import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import Vue from "vue";
import { passwordApi } from "../../plugins/auth-plugin/services/password.api";
import appSnackbarService from "../../services/appSnackbar.service";

@Component({})
export default class ChangeUserPassword extends Vue {
  currentPassword = "";
  password1 = "";
  password2 = "";
  userName = "";
  errorMessage = "";
  valid = false;
  loading = false;

  show1 = false;
  show2 = false;

  passwordRule = v => {
    // if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[a-zA-Z\d\W]{4,}$/.test(v)) {
    if (!/^(?=.*\d)[a-zA-Z\d\W]{4,}$/.test(v)) {
      return (
        "A jelszónak legalább 4 karakterből kell állnia, " +
        "és tartalmaznia kell legalább 1 számot, tartalmazhat még betűt és szimbólumot."
      );
    }
    return true;
  }

  changePassword() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      this.loading = true;
      passwordApi
        .resetUserPassword(this.currentPassword, this.password2)
        .then(() => {
          this.$router.replace("/login");
          appSnackbarService.success(
            "Sikeres jelszo beallitás! Bejelentkezhet az uj jelszoval!"
          );
        })
        .catch(error => {
          this.errorMessage =
            "Hiba tortent a jelszo beállitásakor. ";
          this.loading = false;
        });
    }
  }
}
